export const ListingConstants = {
    NEW_LISTING_REQUEST: 'NEW_LISTING_REQUEST',
    NEW_LISTING_SUCCESS: 'NEW_LISTING_SUCCESS',
    NEW_LISTING_FAILURE: 'NEW_LISTING_FAILURE',

    UPDATE_LISTING_REQUEST: 'UPDATE_LISTING_REQUEST',
    UPDATE_LISTING_SUCCESS: 'UPDATE_LISTING_SUCCESS',
    UPDATE_LISTING_FAILURE: 'UPDATE_LISTING_FAILURE',

    STORE_LISTING: 'STORE_LISTING',

    GETLISTINGS_REQUEST: 'AGENT_GETLISTINGS_REQUEST',
    GETLISTINGS_SUCCESS: 'AGENT_GETLISTINGS_SUCCESS',
    GETLISTINGS_FAILURE: 'AGENT_GETLISTINGS_FAILURE',

    ACTIVE_LISTINGS_REQUEST : 'ACTIVE_LISTINGS_REQUEST',
    ACTIVE_LISTINGS_SUCCESS : 'ACTIVE_LISTINGS_SUCCESS',
    ACTIVE_LISTINGS_FAILURE : 'ACTIVE_LISTINGS_FAILURE',

    FETCH_SINGLE_LISTING_REQUEST : 'FETCH_SINGLE_LISTING_REQUEST', 
    FETCH_SINGLE_LISTING_SUCCESS : 'FETCH_SINGLE_LISTING_SUCCESS',
    FETCH_SINGLE_LISTING_FAILURE : 'FETCH_SINGLE_LISTING_FAILURE',

    FETCH_LISTING_DETAILS_REQUEST : 'FETCH_LISTING_DETAILS_REQUEST',
    FETCH_LISTING_DETAILS_SUCCESS : 'FETCH_LISTING_DETAILS_SUCCESS',
    FETCH_LISTING_DETAILS_FAILURE : 'FETCH_LISTING_DETAILS_FAILURE',

    FETCH_POPULAR_LISTINGS_REQUEST: 'FETCH_POPULAR_LISTINGS_REQUEST',
    FETCH_POPULAR_LISTINGS_SUCCESS: 'FETCH_POPULAR_LISTINGS_SUCCESS',
    FETCH_POPULAR_LISTINGS_FAILURE: 'FETCH_POPULAR_LISTINGS_FAILURE',

    SET_AS_RENTED_REQUEST: 'SET_AS_RENTED_REQUEST',
    SET_AS_RENTED_SUCCESS: 'SET_AS_RENTED_SUCCESS',
    SET_AS_RENTED_FAILURE: 'SET_AS_RENTED_FAILURE',

    UPDATE_LISTING_VIEWS_REQUEST: 'UPDATE_LISTING_VIEWS_REQUEST',
    UPDATE_LISTING_VIEWS_SUCCESS: 'UPDATE_LISTING_VIEWS_SUCCESS',
    UPDATE_LISTING_VIEWS_FAILURE: 'UPDATE_LISTING_VIEWS_FAILURE',

    DELETE_LISTING_REQUEST: 'DELETE_LISTING_REQUEST' , 
    DELETE_LISTING_SUCCESS: 'DELETE_LISTING_SUCCESS', 
    DELETE_LISTING_FAILURE: 'DELETE_LISTING_FAILURE'
};